/*
*
* File JS per il template Archive Magazine
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroBig from 'components/hero-big/hero-big';
import heroImage from 'imComponents/hero-image/hero-image';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import archiveFilters from 'components/archive-filters/archive-filters';
import cardMagazineArchive from 'components/card-magazine-archive/card-magazine-archive';

import pagination from 'components/pagination/pagination';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-magazine.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

archiveFilters();

//--------------------------------------------------------------------//